module.exports = __webpack_public_path__ + "img/payrolls.d6eab2c5.svg";